var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceiptCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "receipt-check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.75 8.375L8.25 9.875L11.625 6.5M15 16.25L15 6.35C15 5.08988 15 4.45982 14.7548 3.97852C14.539 3.55516 14.1948 3.21095 13.7715 2.99524C13.2902 2.75 12.6601 2.75 11.4 2.75L6.6 2.75C5.33988 2.75 4.70982 2.75 4.22852 2.99524C3.80516 3.21095 3.46095 3.55516 3.24524 3.97852C3 4.45982 3 5.08988 3 6.35L3 16.25L5.0625 14.75L6.9375 16.25L9 14.75L11.0625 16.25L12.9375 14.75L15 16.25Z",
    stroke: "currentColor",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptCheck);
export default __webpack_public_path__ + "static/media/receipt_check.5c368b671a823d5ebedc8c3bfe319cfd.svg";
export { ForwardRef as ReactComponent };